import React, { memo } from 'react'

import { SearchPsychologistCard } from '../../../v2/Cards'

const CardComponent = ({
  query,
  filters,
  psychologist,
  timezone,
  onNavigateToPsychologist,
  isFirstConsultation,
  isUserB2B,
  promotionalCoupon,
  accessibleConsultationBanner
}) => {
  return (
    <div itemScope itemType='http://schema.org/Physician' className='col-12'>
      <SearchPsychologistCard
        query={query}
        filters={filters}
        psychologist={psychologist}
        filterTimezone={timezone}
        onNavigateToPsychologist={onNavigateToPsychologist}
        isFirstConsultation={isFirstConsultation}
        isUserB2B={isUserB2B}
        promotionalCoupon={promotionalCoupon}
        accessibleConsultationBanner={accessibleConsultationBanner}
      />
    </div>
  )
}

export default memo(CardComponent, (prev, next) => JSON.stringify(prev) === JSON.stringify(next))
